/**
 * ConfiguracoesShell (A3) — hub unificado de Configurações.
 *
 * Layout fiel ao mockup: cabeçalho (breadcrumb + título) + grid `.set`
 * (rail sticky à esquerda, agrupado por CONTA/APARÊNCIA/DADOS/SISTEMA +
 * conteúdo da aba à direita via <Outlet/>).
 *
 * RBAC por aba: itens sem permissão simplesmente não aparecem no rail.
 * O guard de rota (acesso direto por URL) fica em cada sub-rota (index.jsx).
 */
import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import { GRUPOS, TABS, abaPermitida } from "./tabs";

// Abas que embutem módulos completos (Fase D) — precisam de largura total,
// diferente das abas-formulário (que ficam confortáveis no grid de 1120px).
const ABAS_LARGAS = ["importacoes", "integracoes", "integracoes-cad", "acessos"];

export default function ConfiguracoesShell() {
  const { isMaster, hasAllPermissions, hasAnyPermission, temModulo } = useAuth();
  const ctx = { isMaster, hasAllPermissions, hasAnyPermission, temModulo };
  const { pathname } = useLocation();

  const ativaPath = pathname.replace(/^\/configuracoes\/?/, "").split("/")[0];
  const larga = ABAS_LARGAS.includes(ativaPath);

  const visiveis = TABS.filter((t) => abaPermitida(t.gate, ctx));

  return (
    <section className="screen is-active" style={{ paddingTop: "var(--space-5)" }}>
      <div className="page-header" style={{ marginBottom: 18 }}>
        <div>
          <div className="breadcrumb">
            <span>Início</span>
            <span className="crumb-sep">/</span>
            <span className="active">Configurações</span>
          </div>
          <h1 className="page-title">Configurações</h1>
          <div className="page-sub">
            Perfil, segurança, aparência, dados e integrações — tudo em um lugar.
          </div>
        </div>
      </div>

      <div className={`set ${larga ? "set--wide" : ""}`}>
        <nav className="set-nav" aria-label="Configurações">
          {GRUPOS.map((grupo) => {
            const itens = visiveis.filter((t) => t.grupo === grupo);
            if (!itens.length) return null;
            return (
              <React.Fragment key={grupo}>
                <div className="set-nav__group">{grupo}</div>
                {itens.map((t) => (
                  <NavLink
                    key={t.path}
                    to={t.path}
                    className={({ isActive }) =>
                      `set-nav__item ${isActive ? "is-active" : ""}`
                    }
                  >
                    {t.icone} {t.label}
                  </NavLink>
                ))}
              </React.Fragment>
            );
          })}
        </nav>

        <div className="set-main">
          <Outlet />
        </div>
      </div>
    </section>
  );
}
